<template>
  <div class="admin-product-price-page row-block" :style="{ minHeight: minHeight }">
    <div class="filter-container" :style="{ width: '250px' }">
      <adminFilter
        :minHeight="minHeight"
        :disabled="false"
        :title="'零售價格資料搜尋'"
        :filters="{
          init: init,
          options: filterOptions
        }"
        @changeFilters="(c, search) => { filters = c; search && searchDatas(c) }"
      ></adminFilter>
    </div>
    <div class="main-container row-block" :style="{ flex: 1, height: minHeight }">
      <div v-if="onSearch" class="mask center-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <div class="main-block col-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <div class="title-container row-block">
          <div class="title">零售價格資料管理</div>
          <div :style="{ flex: 1 }"></div>
          <button type="button" name="button" class="main-button option-button update" @click="e => batchUpload()">
            <span>批次上傳</span>
          </button>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="table-feild col-block" :style="{ flex: 1 }">
          <div class="table-container col-block" :style="{ height: '50px' }">
            <div class="thead default-shadow">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="option.class"
                  :style="option.width ? { width: option.width } : { flex: 1 }"
                  @click="e => option.sort !== false && tableSortBy(option.value)"
                >
                  <span>{{ option.title }}</span>
                  <div :style="{ width: '5px' }"></div>
                  <i v-if="option.sort !== false" :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container col-block sub-shadow" :style="{ flex: 1 }">
            <div class="tbody" :style="{ flex: 1 }">
              <div :style="{ height: 0 }">
                <div class="tr row-block" v-for="(productPrice, cindex) in productPrices" :key="cindex">
                  <div class="container-block row-block">
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td"
                      :class="option.class || ['row-block']"
                      :style="option.width ? { width: option.width } : { flex: 1 }"
                    >
                      <div v-if="option.value === '_CHECK'">
                        <div class="check center-block">
                          <img v-if="productPrice.review_status === 'passed'" :src="require('../../assets/images/product-check-true.svg')" alt="">
                          <img v-else-if="productPrice.review_status === 'failed'" :src="require('../../assets/images/product-check-false.svg')" alt="">
                          <div v-else-if="productPrice.review_status === 'not_reviewed'"></div>
                        </div>
                      </div>
                      <div v-else-if="option.value === '_OPTIONS'" :style="{ width: '100%' }">
                        <div class="option row-block">
                          <div class="row-block">
                            <button type="button" name="button" class="main-button option-button update" @click="e => detailProductPrice(productPrice)">
                              <span>{{ productPrice.review_status === 'passed' ? '編輯' : '查核' }}</span>
                            </button>
                          </div>
                          <div :style="{ width: '20px' }"></div>
                          <div v-if="['passed', 'failed'].includes(productPrice.review_status)" class="row-block">
                            <button type="button" name="button" class="main-button delete" @click="e => deleteAdminProductPrice(productPrice)">
                              <i class="fa fa-trash-o" aria-hidden="true"></i>
                            </button>
                          </div>
                          <div v-else :style="{ flex: 1 }"></div>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                      <span v-else :title="(option.display || (x => x))(productPrice[option.value], cindex)" :style="(option.style || (() => {}))(productPrice[option.value])">{{ (option.display || (x => x))(productPrice[option.value], cindex) || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page-container center-block">
            <pageButtons
              v-if="pageData.total"
              :default="pageData.selectedPage"
              :display="pageData.display"
              :total="pageData.total"
              :buttonRange="pageData.buttonRange"
              @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
            ></pageButtons>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getAdminCrops, getAdminProductPrices, deleteAdminProductPrice } from '../../api'
import adminFilter from '../../components/admin/filter'
import pageButtons from '../../components/tool/pageButtons'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { dateFormat } from '../../constants/global/util'

export default {
  components: {
    adminFilter,
    pageButtons
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      productPrices: [],
      cropNames: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    kindOptions () {
      return [
        { title: '蔬菜', value: 'vegetable' },
        { title: '水果', value: 'fruit' }
      ]
    },
    statusOptions () {
      return [
        { title: '通過', value: 'passed' },
        { title: '不通過', value: 'failed' },
        { title: '待審', value: 'not_reviewed' }
      ]
    },
    packingMethodOptions () {
      return [
        { title: '散裝', value: 'bulk', style: { color: '#EF6577' } },
        { title: '有包裝', value: 'packed', style: { color: '#3967A6' } },
        { title: '截切', value: 'cut', style: { color: '#3967A6' } }
      ]
    },
    marketKindOptions () {
      return [
        { title: '傳統市場', value: 'traditional_market' },
        { title: '批發市場', value: 'wholesale_market' },
        { title: '超市', value: 'supermarket' },
        { title: '量販店', value: 'hyper_market' },
        { title: '便利商店', value: 'convenience_store' },
        { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' },
        { title: '農夫(假日)市集', value: 'farmers_market' }
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    cropNameOptions () {
      return this.cropNames.map(data => ({ title: data.name, value: data.name, kind: data.kind }))
    },
    // static
    filterOptions () {
      return [
        {
          title: '產品類別',
          value: 'kind',
          type: 'select',
          options: this.kindOptions,
          placeholder: () => '蔬菜 / 水果',
          onChange: (value, conditions) => {
            this.init = {
              ...this.init,
              ...conditions,
              crop_name: ''
            }
          }
        },
        {
          title: '作物(產品)',
          value: 'crop_name',
          type: 'datalist',
          lists: (value, conditions) => this.cropNameOptions.filter(option => conditions.kind === option.kind && option.title.startsWith(value) && option.title !== value).filter((_, index) => value || index < 99999).map(option => option.title),
          options: this.cropNameOptions,
          placeholder: () => '請輸入產品關鍵字',
          onChange: value => {
            if (value && !this.cropNameOptions.some(option => option.title === value)) {
              this.init = {
                ...this.init,
                ...this.filters,
                crop_name: ''
              }
            }
          }
        },
        {
          title: '市場所在國家',
          value: 'market_country',
          type: 'datalist',
          lists: value => this.countryOptions.map(option => option.title),
          placeholder: () => '請選擇國家',
          onChange: value => {
            if (value && !this.countryOptions.some(option => option.title === value)) {
              this.init = {
                ...this.init,
                ...this.filters,
                market_country: ''
              }
            }
          }
        },
        {
          title: '產地 (國家)',
          value: 'country',
          type: 'datalist',
          lists: value => [{ title: '無', country: { iso_name: '', chinese_name: '' } }, ...this.countryOptions].map(option => option.title),
          placeholder: () => '請選擇國家',
          onChange: value => {
            if (value && value !== '無' && !this.countryOptions.some(option => option.title === value)) {
              this.init = {
                ...this.init,
                ...this.filters,
                country: ''
              }
            }
          }
        },
        {
          title: '資料狀態',
          value: 'review_status',
          type: 'select',
          options: this.statusOptions,
          placeholder: () => '請選擇資料狀態'
        }
      ]
    },
    tableOptions () {
      return [
        {
          title: '',
          value: '_CHECK',
          width: '30px',
          class: ['center-block'],
          sort: false
        },
        {
          title: '上傳者',
          value: 'uploader',
          width: '120px'
        },
        {
          title: '拍攝日期',
          value: 'date',
          width: '120px',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd') : ''
        },
        {
          title: '產品類別',
          value: 'kind',
          width: '100px',
          display: value => (this.kindOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '作物(產品)',
          value: 'crop_name',
          width: '130px'
        },
        {
          title: '產地(國家)',
          value: 'country',
          width: '150px',
          display: value => (this.countryOptions.find(option => option.value === value) || {}).title || '無'
        },
        {
          title: '包裝方式',
          value: 'packing_method',
          width: '100px',
          display: value => (this.packingMethodOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '價格',
          value: 'price',
          width: '80px'
        },
        {
          title: '貨幣單位',
          value: 'currency_name',
          width: '100px'
        },
        {
          title: '市場所在國家',
          value: 'market_country',
          width: '150px',
          display: value => (this.countryOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '市場類型',
          value: 'market_kind',
          width: '100px',
          display: value => (this.marketKindOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '管理',
          value: '_OPTIONS',
          class: ['center-block'],
          sort: false
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchAdminCrops()
      await this.fetchAdminProductPrices()
    },
    async fetchAdminCrops () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getAdminCrops('', config)
        let cropNames = response.data.data
        this.cropNames = cropNames
      } catch (error) {
        throw error
      }
    },
    async fetchAdminProductPrices (filters) {
      try {
        let config = this.$ls.get('userInfo')
        filters = filters || this.filters || {}
        let data = {
          ...Object.entries(filters).filter(kv => kv[1]).reduce((s, kv) => ({ ...s, [kv[0]]: kv[1] }), {}),
          country: filters.country === '無' ? '' : ((this.countryOptions.find(option => option.title === filters.country) || {}).value || null),
          market_country: (this.countryOptions.find(option => option.title === filters.market_country) || {}).value || null
        }
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getAdminProductPrices(data, config)
        let productPrices = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.productPrices = productPrices
      } catch (error) {
        throw error
      }
    },
    async searchDatas (init) {
      this.onSearch = true
      if (init) {
        this.init = init
        this.filter = init
      }
      await this.fetchAdminProductPrices(init)
      this.onSearch = false
    },
    detailProductPrice (productPrice) {
      this.setModalAction({
        action: 'editProductPrice',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: productPrice.review_status === 'passed' ? '零售價格資料編輯' : '零售價格資料查核',
          data: productPrice,
          admin: true,
          image: true,
          review: productPrice.review_status !== 'passed',
          editable: true
        },
        callback: async result => {
          if (result) {
            await this.fetchAdminCrops()
            await this.searchDatas()
          }
        }
      })
    },
    deleteAdminProductPrice (productPrice) {
      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'error',
          content: '<span>此動作不可復原，<br>確認是否刪除該數據 ?</span>',
          buttons: [
            {
              title: '取消',
              type: 'gray',
              icon: 'fa-repeat',
              result: false
            },
            {
              title: '刪除',
              type: 'alert',
              icon: 'fa-trash-o',
              result: true
            }
          ]
        },
        callback: async result => {
          if (result) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let id = productPrice.id
              await deleteAdminProductPrice(id, config)
              this.addToast('success', '刪除成功')
              this.productPrices.splice(this.productPrices.indexOf(productPrice), 1)
              await this.fetchAdminCrops()
              await this.searchDatas()
              this.setLoadingAction(false)
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data)
              this.setLoadingAction(false)
            }
          }
        }
      })
    },
    batchUpload () {
      this.setModalAction({
        action: 'batchUpload',
        width: '600px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        callback: async result => {
          if (result) {
            await this.fetchAdminCrops()
            await this.searchDatas()
          }
        }
      })
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/adminProductPrice.vue